import { render, staticRenderFns } from "./PageMessageDirect.vue?vue&type=template&id=9a57e5dc&scoped=true&"
import script from "./PageMessageDirect.vue?vue&type=script&lang=js&"
export * from "./PageMessageDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a57e5dc",
  null
  
)

export default component.exports